export default __webpack_public_path__ + "static/media/clean-icon.06494555.svg";